import React from "react";
import FaPlus from "react-icons/lib/fa/plus";
import { func } from "prop-types";
import "./AddUserButton.css";

const AddUserButton = ({ onClick }) => {
  return (
    <div className="add-user-button" onClick={onClick}>
      <div className="square">
        <FaPlus size={48} />
      </div>
      <h2>Add new user</h2>
    </div>
  );
};

AddUserButton.propTypes = {
  onClick: func
};

export default AddUserButton;



// WEBPACK FOOTER //
// ./src/components/main/user-management/AddUserButton.js